








































































import Vue from 'vue';
import { Type } from 'expangine-runtime';
import { getProgramDialog } from './GetProgram';
import { getTestProgram, PREF_FULLSCREEN_TEST_PROGRAM } from './TestProgram';
import { Preferences } from './Preference';


export default Vue.extend({
  data: () => getProgramDialog,
  computed: {
    isFullscreen(): boolean {
      return this.$vuetify.breakpoint.mdAndDown || this.fullscreen;
    },
    isFullscreenToggleVisible(): boolean {
      return !this.$vuetify.breakpoint.mdAndDown;
    },
    hasTabs(): boolean {
      return !this.expectedType;
    },
    actualType(): Type | null {
      return this.program.getType(this.registry.defs, this.context);
    },
    actualTypeDescribed(): string {
      return this.actualType
        ? this.registry.getTypeDescribeLong(this.actualType, '&nbsp;&nbsp;', '<br>')
        : '';
    },
    isDisabled(): boolean {
      return !this.actualType;
    },
    isInvalid(): boolean {
      const { actualType, expectedType } = this;

      return !!(expectedType && (!actualType || !expectedType.acceptsType(actualType)));
    },
  },
  methods: {
    toggleFullscreen() {
      this.fullscreen = !this.fullscreen;

      Preferences.set(PREF_FULLSCREEN_TEST_PROGRAM, this.fullscreen);
    },
    cancel() {
      this.close(false);
    },
    ok() {
      this.close(true);
    },
    async test() {
      const { registry, program, context: inputType } = this;

      await getTestProgram({
        registry, 
        program,
        inputType,
      });
    },
  },
});
